// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.csl-deposit-step[data-v-75f3ccd4] {\n    height: 44px;\n    text-align: center;\n    align-content: center;\n    width: 33.33%;\n    padding: 6px 16px !important;\n    clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0 100%, 0 0);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
